import utils from "./utils";
import httpService from "./httpService";

export default {
  findAll(keyword, pageable) {
    let params = utils.merge({keyword: keyword}, pageable);
    return httpService.get("/tltvbAgency", {params: params});
  },

  findAllByUuidIn(uuids) {
    return httpService.get("/tltvbAgency/findAllByUuidIn", {params: {uuids: uuids}});
  },

  findByUuid(uuid) {
    return httpService.get(`/tltvbAgency/${uuid}`);
  },

  findAllDefaultForBanHanh(docId) {
    return httpService.get("/tltvbAgency/findAllDefaultForBanHanh", {params: {docId: docId}});
  },

  findAllForBanHanh(keyword, docId, pageable) {
    let params = utils.merge({keyword: keyword, docId: docId}, pageable);
    return httpService.get("/tltvbAgency/findAllForBanHanh", {params: params});
  },
}



// WEBPACK FOOTER //
// ./src/services/tltvbAgencyService.js